<template>
  <div class="card shadow rounded" :class="calcClass" dir="rtl">
    <CookDishCardHeaderComponent :dish="dish"/>
    <DealInfoComponent :dish="dish" v-if="dish.about.deal" menuView/>
    <DishInfoComponent :dish="dish" v-else :previewMode="true" />
    <HorizontalSplitter />

    <div class="d-flex flex-row f14-l19 margin-20 pointer" dir="rtl" @click="showDish()">
      <div class="flex-fill d-flex flex-column">
        <div v-if="dish.sections.availability" class="one-line-on-carousel" v-html="dish.sections.availability.availability_line"></div>
        <div v-if="dish.sections.availability" v-html="dish.sections.availability.min_order"></div>
      </div>
      <div class="d-flex text-start align-items-center pointer" >
          <a :href="dish.url" class="red-text " target="_blank">{{dish.price_options.labels.order_text}}</a>
      </div>
    </div>



    <!-- <div class="row" style="margin:12px" @click="showDish()">
      <div class="col-9 f14-l18" v-if="dish.sections.availability" v-html="dish.sections.availability.availability_line"></div>
      <div class="col-3 f14-l18 justify-content-end red pointer" style="text-align:left;">
        {{dish.price_options.labels.order_text}}
      </div>
    </div>
    <div class="row" style="margin:12px" @click="showDish()">
      <div class="col-9 f14-l18" v-if="dish.sections.availability" v-html="dish.sections.availability.min_order"></div>
    </div> -->


</div>
</template>
<script>
// /*global bootstrap*/
// import DishPreferenceComponent from "@/components/DishPreferenceComponent.vue";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue";
import CookDishCardHeaderComponent from "@/components/CookDishCardHeaderComponent.vue";
import DealInfoComponent from "@/components/DealInfoComponent.vue";
import DishInfoComponent from "@/components/DishInfoComponent.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
export default {
  components: {
    // DishPreferenceComponent,
    HorizontalSplitter,
    CookDishCardHeaderComponent,
    DealInfoComponent,
    DishInfoComponent
  },
  props: {
    dish: Object
  },
  computed: {
    calcClass() {
      if (this.dish?.search_values?.length > 0) {
        return 'filter-elm-' + this.dish.search_values.join(", filter-elm-")
      }
      return 'filter-elm-0';
    }
  },
  methods: {
    showDish() {
      this.$router.push(this.dish.url);
      this.trackClick();
      // this.$store.dispatch('fetchDish', this.dish.url);
      // let offcanvas = document.getElementById("offcanvasExample");
      // var bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
      // bsOffcanvas.show();
    },
    showCook() {
      this.$router.push(this.dish.sections.cook_info.title.href);
    },
    trackClick() {
      // Trigger Google Tag Manager event
      if (this.dish.data_layer) {
        addGoogleAnalyticsDataLayer(this.dish.data_layer);
      }
    }
  }
}
</script>
